import {HelpUrls} from './help-urls';

export const Translations = {

  PROTOCOL_NOT_SECURED:
    'Stripe requires payment page to be loaded with https. How to setup SSL with HubSpot:\n\n'
    + 'https://knowledge.hubspot.com/website-user-guide/how-to-set-up-ssl-for-a-hubspot-website',
  ACCOUNT_HAS_EXPIRED: 'DepositFix account has expired',
  CREDIT_CARD: 'Credit Card',
  CREDIT_CARD_NUMBER: 'Credit Card Number',
  CVC: 'CVC',
  EXP_DATE: 'Expiration Date',
  PAYMENT_METHOD_PAYPAL: 'PayPal',
  STRIPE_GOOGLE_PAY: 'Google Pay',
  STRIPE_GOOGLE_PAY_COUNTRY_NOT_SUPPORTED: 'Google Pay is not supported in your country',
  STRIPE_GOOGLE_PAY_CREDIT_CARD_MISSING: 'Please add a credit card to your Google Pay wallet',
  STRIPE_APPLE_PAY: 'Apple Pay',
  STRIPE_APPLE_PAY_COUNTRY_NOT_SUPPORTED: 'Apple Pay is not supported in your country',
  STRIPE_APPLE_PAY_CREDIT_CARD_MISSING: 'Please add a credit card to your Apple Pay wallet',
  STRIPE_ACH: 'ACH',
  STRIPE_BACS: 'Bacs Debit',
  // Please keep the spaces at the start and end of OFFLINE_PAYMENT
  OFFLINE_PAYMENT: ' Pay Offline ',
  OFFLINE_PAYMENT_METHOD: 'Pay Offline',
  HOW_OFTEN: 'How often',
  MIN_DONATION : 'Minimum donation is',
  YOUR_DONATION: 'Your Donation Amount',
  INTERVAL_ONE_TIME: 'One time',
  INTERVAL_MONTHLY: 'Monthly',
  PAY_WITH: 'Pay With',
  MULTIPLE_PRODUCTS: 'Product',
  MULTIPLE_SUBSCRIPTIONS: 'Subscription Plan',
  TOTAL: 'Total',
  SUBSCRIPTION: 'Subscription',
  ONE_TIME_CHARGE: 'One time charge',
  QUANTITY: 'Quantity:',
  TAX: 'Tax',
  TAX_BILLING_COUNTRY: 'Billing Country',
  TAX_BILLING_STATE: 'Billing State/Province',
  TAX_BILLING_ZIP: 'Billing Zip',
  TAX_BILLING_ZIP_REQUIRED: 'This field is required',
  DONATION_FREQUENCY: 'Frequency',
  DONATION_AMOUNT: 'Donation Amount',
  DONATION_AMOUNT_INVALID: 'Please put amount greater than 0',
  QUANTITY_INVALID: 'Quantity must be greater than 0',
  PAY_NOW: 'Pay Now',
  PAY_WITH_PAYPAL: 'Pay with PayPal',
  PROCESSING: 'Processing...',
  DISCOUNT: 'Discount',
  DISCOUNT_CODE: 'Discount Code',
  APPLY_DISCOUNT: 'Apply Discount',
  DISCOUNT_APPLIED: 'Discount successfully applied!',
  DISCOUNT_NOT_FOUND: 'Discount code not found',
  DISCOUNT_TRIAL_DAYS_APPLIED: 'days free trial',
  DISCOUNT_FAILED: 'Failed to apply discount',
  SELECT_AT_LEAST_ONE_PRODUCT: 'Please select at least one product',
  COVER_PROCESSING_FEES: 'I\'d like to help cover processing fees on my donation',
  COPYRIGHT: 'by DepositFix',
  TEST_MODE: 'Test Payment Mode',
  CAPTCHA_EXISTS:
    'Captcha doesn\'t work correctly with external form tools like DepositFix, please turn it off:\n\n'
    + HelpUrls.CAPTCHA,
  CAPTCHA_IS_REQUIRED: 'Captcha is required',
  SERVER_NOT_AVAILABLE: 'DepositFix server is not available',
  ADDONS: 'Optional',
  TIMES: 'times',
  STEP_BACK: 'Back',
  STEP_FORWARD: 'Next',
  FORM_SUBMIT_PREVENTED: 'Form submission prevented.',
  COUNTDOWN_IN_PROGRESS: 'Countdown in progress',
  COUNTDOWN_OVER: 'Time is over!'
};
